/**
 * LES DÉTAILS COURTS DU JOURNAL (colonne « Détail » de la fiche contact).
 *
 * En français, quelle que soit la langue du site : c'est l'organisateur qui les lit,
 * dans le back office, comme les libellés des actions eux-mêmes.
 */

/** « Chargement · 4 photos retrouvées », ou le seul geste quand le compte n'est pas connu. */
export function faceUploadLabel(replacing: boolean, found: number | undefined): string {
  const gesture = replacing ? "Changement" : "Chargement";
  if (found === undefined) return gesture;
  if (found === 0) return `${gesture} · aucune photo retrouvée`;
  return `${gesture} · ${found} photo${found > 1 ? "s" : ""} retrouvée${found > 1 ? "s" : ""}`;
}

/**
 * « Atelier LAB A · 15/11 10:00 ». L'heure est l'heure SAISIE, lue en UTC comme partout
 * ailleurs (voir `Slot` dans `funnel/conferences.ts`).
 */
export function slotLabel(title: string, start: string): string {
  const d = new Date(start);
  if (Number.isNaN(d.getTime())) return title;
  const day = new Intl.DateTimeFormat("fr-FR", { day: "2-digit", month: "2-digit", timeZone: "UTC" });
  const hour = new Intl.DateTimeFormat("fr-FR", { hour: "2-digit", minute: "2-digit", timeZone: "UTC" });
  return `${title} · ${day.format(d)} ${hour.format(d)}`;
}

/** Le début d'un texte libre : la question entière reste dans le direct, pas au journal. */
export function startOf(text: string, max = 100): string {
  const flat = text.replace(/\s+/g, " ").trim();
  if (flat.length <= max) return flat;
  const cut = flat.slice(0, max);
  const space = cut.lastIndexOf(" ");
  return space > max / 2 ? cut.slice(0, space) : cut;
}

const CHOICE_WORD: Record<string, string> = { poll: "Sondage", quiz: "Quiz", ballot: "Vote" };

export type LiveLog = {
  action: "liveAnswer" | "liveQuestion" | "liveWord";
  label: string;
};

/**
 * « Sondage · Quel atelier préférez-vous ? · Atelier B ».
 *
 * ⚠️ LE SCRUTIN NE DIT PAS LE CHOIX. Un vote d'AG ou une élection est secret : le
 * journal se lit au back office, il n'y garde que « A voté ».
 */
export function liveLog(
  activity: { type: string; title: string; choices: ReadonlyArray<{ id: number; label: string }> },
  submitted: { choiceIds?: number[]; text?: string },
): LiveLog | null {
  if (activity.type === "cloud" && submitted.text) {
    return { action: "liveWord", label: submitted.text.trim() };
  }
  if (activity.type === "questions" && submitted.text) {
    return { action: "liveQuestion", label: startOf(submitted.text) };
  }
  const word = CHOICE_WORD[activity.type];
  if (!word || !submitted.choiceIds?.length) return null;
  if (activity.type === "ballot") return { action: "liveAnswer", label: `Vote · ${activity.title} · A voté` };
  const chosen = activity.choices
    .filter((c) => submitted.choiceIds!.includes(c.id))
    .map((c) => c.label)
    .join(", ");
  return { action: "liveAnswer", label: [word, activity.title, chosen].filter(Boolean).join(" · ") };
}
